/**
 * Music Notes
 * @type {Array}
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = ['A', 'A# / Bb', 'B', 'C', 'C# / Db', 'D', 'D# / Eb', 'E', 'F', 'F# / Gb', 'G', 'G# / Ab'];
module.exports = exports['default'];